const Settings = () => import(/* webpackChunkName: "settings" */ '@/views/settings/Index');
const Notifications = () => import(
  /* webpackChunkName: "settings" */ '@/views/settings/Notifications'
);
const Integrations = () => import(
  /* webpackChunkName: "settings" */ '@/views/settings/Integrations'
);

export default {
  path: '/settings',
  component: Settings,
  children: [
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'integrations',
      name: 'Integrations',
      component: Integrations
    }
  ]
};
